/* eslint-disable */
import { authService } from '@/services/auth.service';

let __cachedMe: any = null;
let __inflightMe: Promise<any> | null = null;

export async function getAuthStatus(): Promise<any | null> {
  if (typeof window === 'undefined') return null;
  if (__cachedMe !== null) return __cachedMe;
  if (__inflightMe) return __inflightMe;
  
  __inflightMe = authService.getSession()
    .then((d: any) => {
      // To-Be 형식 변환
      if (d && d.code === "SUCCESS" && d.data) {
        const user = d.data;
        const lastPwdChange = user.lastPwdChange;
        const password90Expired = lastPwdChange ? 
          (Date.now() - new Date(lastPwdChange).getTime()) > 90 * 24 * 60 * 60 * 1000 : false;
        
        const converted = {
          ok: true,
          user: {
            id: String(user.id),
            email: user.email,
            name: user.name,
            code: user.code,
            phone: user.phone,
            company: user.company,
            activationExpiresAt: user.activationExpiresAt,
            lastPwdChange: user.lastPwdChange,
            approvalCode: user.approvalCode,
          },
          password90Expired,
          needsConsent: false, // TODO: API에서 반환하도록 수정 필요
          emailSubscribed: false, // TODO: API에서 반환하도록 수정 필요
        };
        __cachedMe = converted;
        return converted;
      } else if (d && d.code === "ERROR") {
        __cachedMe = { ok: false, reason: d.details?.reason };
        return __cachedMe;
      }
      __cachedMe = d;
      return d;
    })
    .catch(() => null)
    .finally(() => { __inflightMe = null; });
  return __inflightMe;
}

export function clearAuthCache() {
  __cachedMe = null;
}


